import { SearchCriteria } from 'src/app/core/interfaces/search-criteria.interface';
import { FIELD_PRIORITY_WEIGHT, SEARCH_FIELD, SearchPriorityConfig } from 'src/app/core/interfaces/search-priority-config';
import { CollectionFinderItemDTO } from 'src/app/core/interfaces/collection.interface';

export class CollectionTargetGroupsCriteria implements SearchCriteria {
  getMatchScore(_collection: CollectionFinderItemDTO, _query: string): number {
    return _collection.targetGroups?.some(targetGroup => targetGroup.displayName.toLowerCase().includes(_query)) ? 1 : 0;
  }

  getRelevanceFieldWeightAndMatchScore(_collection: CollectionFinderItemDTO, _query: string): SearchPriorityConfig {
    return {
      relevanceField: SEARCH_FIELD.ORG_UNIT,
      fieldPriorityWeight: FIELD_PRIORITY_WEIGHT.ORG_UNIT,
      matchScore: this.getMatchScore(_collection, _query),
    }
  }
}